import { render, staticRenderFns } from "./CarDetails.vue?vue&type=template&id=8ce5f226&"
import script from "./CarDetails.vue?vue&type=script&lang=js&"
export * from "./CarDetails.vue?vue&type=script&lang=js&"
import style0 from "./CarDetails.vue?vue&type=style&index=0&id=8ce5f226&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports